import { render, staticRenderFns } from "./OrganizationOverview.vue?vue&type=template&id=ae980e02&"
import script from "./OrganizationOverview.vue?vue&type=script&lang=js&"
export * from "./OrganizationOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports